import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Row,
  Space,
} from "antd";

import { PlatformType } from "types/platform-types";
import { create, get, update } from "services/platform.service";
import PlatformBotMapping from "pages/platform/mapping/platform-bot-mapping";

const PlatformForm: React.FC = () => {
  const { code } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [saving, setSaving] = useState<boolean>(false);
  const [isCreate, setCreate] = useState<boolean>(false);

  useEffect(() => {
    const initForm = async () => {
      const platforms: PlatformType[] = await get({ code });
      if (platforms && platforms.length >= 1) {
        form.setFieldsValue({ ...platforms[0] });
      }
    };

    if (!!code) {
      initForm();
    }

    setCreate(!code);

    return () => form.resetFields();
  }, [form, code]);

  const onSubmit = async () => {
    try {
      setSaving(true);
      const values = await form.validateFields();
      const newValues = {
        ...values,
        code,
      };
      if (!isCreate) {
        await update(newValues);
      } else {
        await create(newValues);
      }
      message.success(`Platform ${values?.["name"]} is saved successfully`);
      isCreate && navigate("/platform/list");
    } catch (ex: any) {
      if (ex?.response?.data?.message) {
        message.error(ex?.response?.data?.message);
      } else {
        message.error("Platform is saved failed");
      }
    } finally {
      setSaving(false);
    }
  };

  const goBack = () => {
    navigate("/platform/list");
  };

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false} className="criclebox">
              <Form
                layout="horizontal"
                className="row-col"
                form={form}
                labelCol={{ span: 2 }}
                wrapperCol={{ xs: 24, md: 9 }}
              >
                <Form.Item
                  className="name"
                  label="Platform Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input platform name!",
                    },
                  ]}
                >
                  <Input placeholder="Platform Name" />
                </Form.Item>
                <Form.Item
                  className="isAutoAddAgent"
                  label="Auto Add Agent"
                  name="isAutoAddAgent"
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
                <Space>
                  <Button type="primary" onClick={onSubmit} loading={saving}>
                    Save
                  </Button>
                  <Button onClick={goBack} loading={saving}>
                    Back
                  </Button>
                </Space>
              </Form>
            </Card>
          </Col>
        </Row>
        {!isCreate && (
          <Card>
            <PlatformBotMapping platformCode={code ?? ""} />
          </Card>
        )}
      </div>
    </>
  );
};

export default PlatformForm;
